// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hWb1","questions":"styles_questions__3XQI3","footer":"styles_footer__2p4Vj"};